import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentLinkSkeleton } from './TypeComponentLink'
import type { TypeTranslationsSkeleton } from './TypeTranslations'

export interface TypeComponentHubSpotFormFields {
  internalName: EntryFieldTypes.Symbol
  headline?: EntryFieldTypes.Symbol
  subtext?: EntryFieldTypes.RichText
  formId: EntryFieldTypes.Symbol
  submitText: EntryFieldTypes.Symbol
  afterSubmitLink?: EntryFieldTypes.EntryLink<TypeComponentLinkSkeleton>
  afterSubmitText?: EntryFieldTypes.Symbol
  translations?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeTranslationsSkeleton>>
  plausibleEventName?: EntryFieldTypes.Symbol
  customErrorMessage?: EntryFieldTypes.RichText
  formSize?: EntryFieldTypes.Symbol<'Large' | 'Medium' | 'Small'>
  postFormText?: EntryFieldTypes.RichText
}

export type TypeComponentHubSpotFormSkeleton = EntrySkeletonType<TypeComponentHubSpotFormFields, 'componentHubSpotForm'>
export type TypeComponentHubSpotForm<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeComponentHubSpotFormSkeleton,
  Modifiers,
  Locales
>

export function isTypeComponentHubSpotForm<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeComponentHubSpotForm<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'componentHubSpotForm'
}
